module.exports = "<div appInitTheme>\n  <app-header></app-header>\n  <div *ngIf=\"warningMessages && warningMessages.length > 0\">\n    <app-message [messages]=\"warningMessages\" [type]=\"'broadcast'\"></app-message>\n  </div>\n  <main role=\"main\" class=\"container-fluid app-content-panel\">\n    <router-outlet></router-outlet>\n  </main>\n  <app-footer></app-footer>\n</div>"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/auth-shell/auth-shell.component.html
// module id = ../../../../../src/app/auth-shell/auth-shell.component.html
// module chunks = main